import { StateIterator } from "./state/StateIterator.js";
import { ServerId } from "../accessorTree/RuntimeId.js";
import { HasOneRelationMarker } from "../markers/HasOneRelationMarker.js";
import { HasManyRelationMarker } from "../markers/HasManyRelationMarker.js";
import { assertNever } from "../utils/assertNever.js";
class TreeFilterGenerator {
  constructor(treeStore) {
    this.treeStore = treeStore;
  }
  generateTreeFilter() {
    const filters = [];
    for (const [placeholderName, state] of StateIterator.eachRootState(this.treeStore)) {
      const blueprint = state.blueprint;
      if (blueprint.parent || blueprint.marker.parameters.expectedMutation === "none") {
        continue;
      }
      const marker = blueprint.marker;
      filters.push(this.generateSubTreeFilter(marker, this.treeStore.subTreePersistedData.get(placeholderName)));
    }
    return filters.flat();
  }
  generateSubTreeFilter(subTree, persistedData) {
    const filters = [];
    if (persistedData === void 0) {
      return filters;
    }
    if (persistedData instanceof ServerId) {
      const filter = this.generateTopLevelEntityFilter(
        persistedData.value,
        subTree.parameters.entityName,
        subTree.fields
      );
      filter && filters.push(filter);
    } else {
      for (const id of persistedData) {
        const filter = this.generateTopLevelEntityFilter(id, subTree.parameters.entityName, subTree.fields);
        filter && filters.push(filter);
      }
    }
    return filters;
  }
  generateTopLevelEntityFilter(id, entityName, fields) {
    return {
      entity: entityName,
      id,
      relations: this.generateEntityRelations(fields)
    };
  }
  generateEntityRelations(markers) {
    const rawFilter = this.populateRawRelationFilters(markers);
    return this.normalizeRawRelationFilters(rawFilter);
  }
  normalizeRawRelationFilters(raw) {
    return Array.from(raw, ([fieldName, relations]) => ({
      name: fieldName,
      relations: this.normalizeRawRelationFilters(relations)
    }));
  }
  populateRawRelationFilters(markers, relations = /* @__PURE__ */ new Map()) {
    for (const [, marker] of markers.markers) {
      if (!(marker instanceof HasOneRelationMarker) && !(marker instanceof HasManyRelationMarker)) {
        continue;
      }
      if (marker.parameters.expectedMutation === "none" || marker.parameters.expectedMutation === "connectOrDisconnect") {
        continue;
      } else if (marker.parameters.expectedMutation === "anyMutation" || marker.parameters.expectedMutation === "createOrDelete")
        ;
      else {
        return assertNever(marker.parameters.expectedMutation);
      }
      let existingRelation = relations.get(marker.parameters.field);
      if (existingRelation === void 0) {
        relations.set(marker.parameters.field, existingRelation = /* @__PURE__ */ new Map());
      }
      this.populateRawRelationFilters(marker.fields, existingRelation);
    }
    return relations;
  }
}
export {
  TreeFilterGenerator
};
//# sourceMappingURL=TreeFilterGenerator.js.map
